import { render, staticRenderFns } from "./ChallengerDetailCommunityUsers.vue?vue&type=template&id=69adb1a7&scoped=true"
import script from "./ChallengerDetailCommunityUsers.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailCommunityUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69adb1a7",
  null
  
)

export default component.exports